import request from '@/utils/request'

// 附加费
// export const exetaFee_list=(data)=>{
//   return request({
//     url: '/erp/base-supplier/list',
//     method: 'get',
//     data
//   })
// }

// 附加费 新增 || 编辑
export const exetaFee_update=(data)=>{
  return request({
    url: '/erp/base-surcharge/create',
    method: 'post',
    data
  })
}
